import { AxiosInstance } from "axios";
import { getDetails, getMoreDetails } from "@/services/api/meeting";

export const getMeetingDetails = async (apiClient: AxiosInstance) => {
  const serverDetails = await getDetails(apiClient);
  const data = await getMoreDetails(apiClient, serverDetails.event_id);

  return {
    ...data,
    ...serverDetails
  };
};
